import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';
import { getLocalStorage, LOCAL_STORAGE_NAMES } from '@libs/storage/src/lib/local';

export const userApi = createApi({
  reducerPath: 'user.api',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NX_API_URL,
    prepareHeaders: (headers) => {
      const token = getLocalStorage(LOCAL_STORAGE_NAMES.TOKEN);

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['user'],
  endpoints: (builder) => ({
    findPassword: builder.mutation({
      query: (body) => ({
        url: '/api/users/find-password',
        method: 'POST',
        body,
      }),
    }),
    getUserById: builder.query({
      query: (id) => ({ url: `/api/users/${id}` }),
      providesTags: ['user'],
    }),
    getUserList: builder.query({
      query: (data) => ({
        url: `/api/users`,
        params: data,
        method: 'GET',
      }),
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: Number(meta?.response?.headers.get('X-Total-Count')),
        };
      },
      forceRefetch(params) {
        return true;
      },
    }),
    getUserGroupList: builder.query({
      query: (data) => ({
        url: `/api/user-groups`,
        params: data,
        method: 'GET',
      }),
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: Number(meta?.response?.headers.get('X-Total-Count')),
        };
      },
      forceRefetch(params) {
        return true;
      },
    }),
  }),
});

export const { useFindPasswordMutation, useLazyGetUserByIdQuery, useGetUserListQuery, useGetUserGroupListQuery } =
  userApi;
